import { gql } from "@apollo/client"
import { getTreeIdFromItem } from "lib/get-tree-id-from-item"

import { mutate } from "lib/graphql/mutate"
import { getScheduleRecordId } from "library/get-unique-id-from-tree.mjs"

export async function setGroupPayload(group, key, payload) {
    const tree = getTreeIdFromItem(group)
    const groupId = getScheduleRecordId(group.id)
    return mutate(
        gql`
            mutation setPayloadData($tree: String!, $group: String!, $key: String!, $payload: JSONObject!) {
                setGroupPayload(payload: $payload, tree: $tree, group: $group, key: $key)
            }
        `,
        {
            tree,
            group: groupId,
            payload,
            key,
        },
        { returns: "setGroupPayload" }
    )
}
